module.exports = __webpack_public_path__ + "static/media/NoInvoice.023752ce.pdf";